import React from "react";
import { component_tool, utils_tool } from "@/tool";
import { WizTableForm } from '@/containers/common';
import BatchAudit from "./batchAudit";
import StudentCommentDetail from "./studentCommentDetail";
import moment from 'moment';

const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
let { WizModal, WizCard, WizPopover } = component_tool;
let { $$, checkStrLength } = utils_tool;
//配置项
let componentName = 'studentCommentManagement';
let ref;
let refAlone;
let refLookDetail;
const columns = (data) => {
  const { pathCommentName } = data;
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    pathCommentName !=null && pathCommentName!='' && pathCommentName!=undefined && pathCommentName!='null' ? {
      title: "评语",
      searchItem: {
        type: 'custom',
        render: () => {
          return <span>{pathCommentName}</span>
        }
      }
    }:{

      title: "评语",
      name: "pathCommentName",
      searchItem: {
      }
    },
    {
      title: "姓名",
      name: "fullName",
      tableItem: {},
      searchItem: {}
    },
    {
      title: "账号",
      name: "userName",
      tableItem: {},
      searchItem: {}
    },
    {
      title: "手机号",
      name: "mobile",
      tableItem: {},
    },
    /* {
      title: "证件号码",
      name: "idCard",
      tableItem: {},
    }, */
    {
      title: '任职',
      name: 'userIdentityInfos',
      tableItem: {
        // ellipsis: true,
        render: (text, record) => {
          let contextList = text && text.split(',').length ? text.split(',') : []
          let content = [];
          let title = ''
          contextList && contextList.length && contextList.map((d, index) => {
            if (index === 0) {
              title = d
            }
            content.push(<p key={index}>{d}</p>)
          })
          let _titleView = []
          _titleView.push(title)
          if (contextList && contextList.length > 1) {
            _titleView.push(<span className='wiz-press-font-color'> ...</span>)
          }
          return (
            <WizPopover content={content} placement="rightTop">
              {_titleView}
            </WizPopover>
          )
        }
      }
    },
    {
      title: "组织",
      name: "orgId",
      searchItem: {
        diy: WizTableForm,
        ...organizationConfig,
        selectType: 'radio',
      }
    },
    {
      title: '岗位',
      name: 'positionId',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm,
        selectType: 'radio'
      },
    },
    {
      title: "评语状态",
      name: "state",
      dict: [
        { code: 1, codeName: "待审核" },
        { code: 2, codeName: "已通过" },
        { code: 3, codeName: "驳回" }
      ],
      searchItem: {
        type: "select"
      },
      tableItem: {},
    },
    {
      title: "提交时间",
      name: "submitTime",
      tableItem: {},
    },
    {
      title: "审核时间",
      name: "auditTime",
      tableItem: {},
    },
    {
      title: '提交时间',
      name: 'submitTimeDate',
      dataIndex: "submitTimeDate",
      searchItem: {
        type: 'date~',
        showTime: true
      },
    },
    {
      title: '审核时间',
      name: 'auditTimeDate',
      dataIndex: "auditTimeDate",
      searchItem: {
        type: 'date~',
        showTime: true
      },
    },
  ]
};

const templateConfig = (data) => {
  const { onSelect, _btnLookUserFun, _btnLookCommentFun, _this } = data;
  let _onSelect = (key, rows) => {
    onSelect && onSelect(key, rows);
    ref && ref.getSelectRows(rows)
  };
  let initRows = () => {
    return _this.state.selectedStudentCommentRows
  };

  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(data),
        searchBarProps: {
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            if (value.submitTimeDate && value.submitTimeDate.length === 2) {
              value.submitTimeStart = moment(value.submitTimeDate[0]).format('YYYY-MM-DD HH:mm:ss')
              value.submitTimeEnd = moment(value.submitTimeDate[1]).format('YYYY-MM-DD HH:mm:ss')
            }
            if (value.auditTimeDate && value.auditTimeDate.length === 2) {
              value.auditTimeStart = moment(value.auditTimeDate[0]).format('YYYY-MM-DD HH:mm:ss')
              value.auditTimeEnd = moment(value.auditTimeDate[1]).format('YYYY-MM-DD HH:mm:ss')
            }
            // delete value.time
            return value
          },
          // collapse: false,
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttonSort: ['batchReview','export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams:(rows,record,filters,callback)=>{
                  return {...filters}
                }
              }
            },
            {
              key: "batchReview",
              custom: true,
              needSelect: true,
              params: { children: "批量审核", type: "info" },
              customOnClick: {
                key: "modal",
                params: {
                  modalKey: new Date().getTime(),
                  modalParams: {
                    title: "评语审核",
                    footer: null,
                    diy: (e) => {
                      e.record = Object.assign({}, e.record)
                      return (
                        <BatchAudit
                          {...e}
                          key={'Input' + e.record.id}
                          initRows={initRows}
                          ref={r => {
                            ref = r && r.getWrappedInstance();
                          }}
                          timeStamp={new Date().getTime()}
                        />
                      )
                    },
                    onOk: () => {
                      ref._ok();
                    },
                    onCancel: () => {
                      ref._doInitParams()
                    },
                    width: 600
                  }
                },
                formatParams: (rows, record, filters, callback) => {
                  if (!rows) return;
                  if ($$.isArray(rows) && !rows.length) return;
                  let canAudit = true;
                  rows.forEach(e => {
                    if (e['state'] !== 1) {
                      canAudit = false;
                    }
                  });
                  if (!canAudit) {
                    wizNotice.error('请选择待审核的评语进行审核！');
                    return;
                  }
                  return { rows }
                }
              }
            },
          ]
        },
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
          onSelect: _onSelect,
          rowSelection: {
            getCheckboxProps: (record) => {
              return { disabled: record['state'] !== 1 };
            },
          },
          needOnRowSelect: (record, index) => {
            return record['state'] === 1
          },
        },
        rowOperateSort: ['review', 'viewComments', 'viewAuditOpinion'],
        rowOperateView: [
          {
            key: "review",
            custom: true,
            params: { children: "审核" },
            recordChangeParams: (record, rows) => {
              let result = { disabled: false };
              if (record.record && (record.record.state === 2 || record.record.state === 3)) {
                result.disabled = true
              }
              return result
            },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                // pathname: "/comment/trainPathCommentAudit/auditComment"
                pathname: "/comment/auditComment"
              }
            }
          },
          // {
          //   key: "auditComment",
          //   custom: true,
          //   params: {children: "审核"},
          //   recordChangeParams: (record, rows) => {
          //     let result = { disabled: false };
          //     if (record.record && (record.record.state === 2 || record.record.state === 3)) {
          //       result.disabled = true
          //     }
          //     return result
          //   },
          //   customOnClick: {
          //     key: "modal",
          //     params: {
          //       modalKey: 'modalKey_auditComment_'+new Date().getTime(),
          //       modalParams: {
          //         title: "评语审核",
          //         footer: null,
          //         diy: (e) => {
          //           e.record = Object.assign({}, e.record)
          //           return (
          //             <BatchAudit
          //               {...e}
          //               key={'aloneAudit' + e.record.id + new Date().getTime()}
          //               initRows={initRows}
          //               ref={r => {
          //                 refAlone = r && r.getWrappedInstance();
          //               }}
          //               timeStamp={new Date().getTime()}
          //               alone={true}
          //             />
          //           )
          //         },
          //         onOk: () => {
          //           refAlone._ok();
          //         },
          //         onCancel: () => {
          //           refAlone._doInitParams()
          //         },
          //         width: 600
          //       }
          //     },
          //     formatParams: (rows, record, filter) => {
          //       return {...record};
          //     }
          //   }
          // },
          {
            key: "viewComments",
            name: "WizButton",
            params: {
              children: "查看评语",
              key: "_btnComment",
            },
            onClick: e => _btnLookCommentFun && _btnLookCommentFun(e),
          },
          // {
          //   key: "look",
          //   name: "WizButton",
          //   params: {
          //     children: "查看任职",
          //     key: "_btnUser",
          //   },
          //   onClick: e => _btnLookUserFun && _btnLookUserFun(e),
          // },
          {
            key: "viewAuditOpinion",
            custom: true,
            params: { children: "查看审核意见" },
            recordChangeParams: (record, rows) => {
              let result = { disabled: false };
              if (record.record && (record.record.state === 1)) {
                result.disabled = true
              }
              return result
            },
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  title: "查看审核意见",
                  footer: null,
                  style: { minWidth: 500 },
                  diy: (e) => {
                    let record = e && e['record']
                    return (
                      <WizCard>
                        <div dangerouslySetInnerHTML={{ __html: record['auditReason'] }} />
                      </WizCard>
                    )
                  }
                }
              },
              formatParams: (rows, record, filters, callback) => {
                return { ...record }
              }
            }
          },
        ],
        commonOperate: {
          add: false,
          delete: false,
          look: false
        }
      }
    }
  };
};

const apis = (data) => {
  const { pathCommentId } = data;
  return {
    list: {
      path: `${componentName}/pageList`,
      payload: {
        key: `${componentName}@pageList`,
        apiParams: { pageNum: 1, pageSize: 10, pathCommentId }
      }
    },
    export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {pathCommentId}
    }
  }
  }
};


let reduxTemplateConfig = (args) => {
  const { pathCommentId } = args;
  return {
    apis: apis({ pathCommentId }),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
